/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'

export function AsideMenuManage() {
  const intl = useIntl()

  return (
    <>
      <div className='menu-item'>
        <div className='menu-content pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Quản lý khu vực</span>
        </div>
      </div>
      <AsideMenuItem
        to='/sales'
        icon='/media/svg/custom/icn_revenue.svg'
        title='Doanh số'
        fontIcon='bi-layers'
      />
      <AsideMenuItemWithSub
        to='/manage-client'
        title='Quản lý khách hàng'
        icon='/media/svg/custom/icn_partner.svg'
        fontIcon='bi-person'
      >
        <AsideMenuItem to='/manage-client/report-new-client' title='Báo cáo số lượng KH mới' hasBullet={true} />
        {/* <AsideMenuItem to='/manage-client/client-category' title='Danh mục khách hàng' hasBullet={true} /> */}
      </AsideMenuItemWithSub>
      {/* <AsideMenuItem
        to='/partners'
        icon='/media/svg/custom//icn_partner.svg'
        title='Đối tác'
        fontIcon='bi-layers'
      /> */}
      <AsideMenuItem
        to='/installment-package'
        icon='/media/svg/custom//icn_poll.svg'
        title='Gói trả góp'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/office-management/offices'
        icon='/media/svg/custom/icn_location.svg'
        title='Quản lý văn phòng'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
    </>
  )
}
